import axios from 'axios'

// create an axios instance
const service = axios.create({
  // baseURL: '/api', // url = base url + request url
  baseURL: process.env.NODE_ENV === 'production'
  ? '/sk-website-api' : '/api',
  // 'http://212.129.152.24:80/sk-website-api',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.errcode === 2 || response.data.errcode === 3) {
      // to re-login
    }
     // console.log(response)
    if (response.data.errcode !== 0) {
      return Promise.reject(new Error(response.msg || 'Error'))
    } else {
      return response.data.data
    }
  },
  error => {
    // console.log('err' + error) // for debug
    // store.dispatch('user/resetToken').then(() => {
    //   location.reload()
    // })
    return Promise.reject(error)
  }
)

export default service
